import { fg } from '@atlaskit/platform-feature-flags';

import type { SearchResult, SearchResultType } from '../../../../common/types';

export const SearchResultAssetsObjectSchema = `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		links {
			web
		}
	}
}
`;

export interface SearchResultAssetsObjectSchema extends SearchResult {
	id: string;
	title: string;
	type: SearchResultType;
	description: string;
	lastModifiedDate: string;
	objectSchemaEntity: {
		name?: string;
		displayName?: string;
		links: {
			web: string;
		};
	};
	__typename: 'SearchResultAssetsObjectSchema';
}

export const isSearchResultAssetsObjectSchema = (
	partial: SearchResult,
): partial is SearchResultAssetsObjectSchema => {
	return partial.__typename === 'SearchResultAssetsObjectSchema';
};

export const getSearchResultAssetsObjectSchema = () => {
	return `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		${fg('cdm_ga') ? 'name displayName' : ''}
		links {
			web
		}
	}
}
	`;
};

export const SearchResultAssetsObjectType = `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		icon {
			url48
		}
		links {
			web
		}
	}
}
`;

export interface SearchResultAssetsObjectType extends SearchResult {
	id: string;
	title: string;
	type: SearchResultType;
	description: string;
	lastModifiedDate: string;
	objectSchemaEntity: {
		id: string;
		name: string;
		displayName?: string;
		links: {
			web: string;
		};
	};
	objectTypeEntity: {
		name?: string;
		displayName?: string;
		icon: {
			url48: string;
		};
		links: {
			web: string;
		};
	};
	__typename: 'SearchResultAssetsObjectType';
}

export const isSearchResultAssetsObjectType = (
	partial: SearchResult,
): partial is SearchResultAssetsObjectType => {
	return partial.__typename === 'SearchResultAssetsObjectType';
};

export const getSearchResultAssetsObjectType = () => {
	return `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		${fg('cdm_ga') ? 'displayName' : ''}
		links {
			web
		}
	}
	objectTypeEntity {
		${fg('cdm_ga') ? 'name displayName' : ''}
		icon {
			url48
		}
		links {
			web
		}
	}
}
	`;
};

export const SearchResultAssetsObject = `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name

	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
`;

export interface SearchResultAssetsObject extends SearchResult {
	id: string;
	title: string;
	description: string;
	lastModifiedDate: string;
	type: SearchResultType;
	schemaAri: string;
	typeAri: string;
	objectSchemaEntity: {
		id: string;
		name: string;
		displayName?: string;
		links: {
			web: string;
		};
	};
	objectTypeEntity: {
		id: string;
		name: string;
	};
	objectEntity: {
		avatar: {
			url48: string;
		};
		links: {
			web: string;
		};
	};
	__typename: 'SearchResultAssetsObject';
}

export const isSearchResultAssetsObject = (
	partial: SearchResult,
): partial is SearchResultAssetsObject => {
	return partial.__typename === 'SearchResultAssetsObject';
};

export const getSearchResultAssetsObject = () => {
	return `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		${fg('cdm_ga') ? 'displayName' : ''}
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name
	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
	`;
};

export type SearchAssetsPartial =
	| SearchResultAssetsObjectSchema
	| SearchResultAssetsObjectType
	| SearchResultAssetsObject;

export const isSearchAssetsPartial = (partial: SearchResult): partial is SearchAssetsPartial => {
	return (
		isSearchResultAssetsObjectSchema(partial) ||
		isSearchResultAssetsObjectType(partial) ||
		isSearchResultAssetsObject(partial)
	);
};

export const getAssetsPartials = () => {
	return `
		${getSearchResultAssetsObjectSchema()}
		${getSearchResultAssetsObjectType()}
		${getSearchResultAssetsObject()}
	`;
};
